// extracted by mini-css-extract-plugin
module.exports = {"relatedProductsTitle":"relatedProducts_relatedProductsTitle__0_Zwm"};